import { StrictMode } from "react";
import * as ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import { ENV, config } from "@coffee/config";
import { store } from "@coffee/data-access/api-service";
import { createMockServer } from "@unlikelyai-magic/shared/mocking";
import App from "./app/App";
import "./app/App.css";
import { mockApi } from "./msw/mswHandlers";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const render = async () => {
  // setup MSW endpoints
  if (config.ENV === ENV.DEVELOPMENT) {
    const mockServer = createMockServer(mockApi);
    await mockServer.listen();
  }

  root.render(
    <StrictMode>
      <Auth0Provider
        domain={config.AUTH0.DOMAIN}
        clientId={config.AUTH0.CLIENT_ID}
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: config.AUTH0.AUDIENCE,
          scope: "email",
        }}
      >
        <BrowserRouter>
          <Provider store={store}>
            <App />
          </Provider>
        </BrowserRouter>
      </Auth0Provider>
    </StrictMode>
  );
};

render();
